import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Tabs from '../../../../../Components/Tabs';
import ServiceEstimateScreen from '../ServiceEstimateScreen';
import InvoiceBillScreen from '../InvoiceBillScreen';
import InvoiceReceiptScreen from '../InvoiceReceiptScreen';
import InvoiceSettingsController from '../../../../Controllers/AdminScreens/Invoices/Settings/InvoiceSettingsController';
import InvoiceSettingsConfigurationsScreen from './InvoiceSettingsConfigurationsScreen';
import InvoiceReceiptNotesScreen from './InvoiceReceiptNotesScreen';
import InvoiceOrganizationScreen from './InvoiceOrganizationScreen';
import InvoiceReceiptBooksScreen from './InvoiceReceiptBooksScreen';
import InvoiceTaxationScreen from './InvoiceTaxationScreen';
import InvoiceOtherSettingsScreen from './InvoiceOtherSettingsScreen';
import InvoiceServiceEstimateSeriesScreen from './InvoiceServiceEstimateSeriesScreen';
import InvoiceSeriesScreen from './InvoiceSeriesScreen';
import InvoiceReceiptSeriesScreen from './InvoiceReceiptSeriesScreen';
import InvoicePaymentGatewayScreen from './InvoicePaymentGatewayScreen';
const InvoiceSettingsScreen = () => {

    const {
        estimateSeries, loadingEstimate, errorEstimate,
        invoiceSeries, loadingInvoice, errorInvoice,
        receiptSeries, loadingReceipt, errorReceipt,
        taxSgst, taxCgst, taxIgst, taxConvFee, bookOpenBalance, narration, notes, overdueDays,
        loadingSettings, errorSettings,
        invoiceRefresh,
        fetchEstimateSeriesHistory, fetchInvoiceSeriesHistory, fetchReceiptSeriesHistory,
        showServiceEstimateSeries, showInvoiceSeries, showReceiptSeries,
        editServiceEstimateSeries, editInvoiceSeries, editReceiptSeries,
        selectedServiceEstimate, selectedInvoiceSeries, selectedReceiptSeries,
        toggleServiceEstimateSeries, toggleInvoiceSeries, toggleReceiptSeries,
        toggleUpdateServiceEstimateSeries, toggleUpdateInvoiceSeries, toggleUpdateReceiptSeries,
        paymentData,paymentError,paymentLoading,fetchPaymentConfig,
    } = InvoiceSettingsController();

    const { state } = useLocation();
    const [selectedTab, setSelectedTab] = useState(state?.selectedTab || 0);
    const [selectedSubTab, setSelectedSubTab] = useState(state?.selectedTab || 0);
    const [disabledTabs, setDisabledTabs] = useState([]);

    useEffect(() => {
        const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_') || '{}');
        const { per_name_sub_json } = storedUserInfo?.user_permissions?.invoice_settings || {};
        const tabPermissions = [
            { name: "Configuration", key: "i_s_config"},
            { name: "Receipt Narration & Notes", key: "i_s_narration"},
            { name: "Manage Tax", key: "i_s_manage_tax"},
            { name: "Other Setting", key: "i_s_other_settings"}
        ]

        const disabledTabIndices = tabPermissions
            .map((tab, index) => (per_name_sub_json[tab?.key] !== 1 ? index : null))
            .filter(index => index !== null);
        console.log('disabledTabIndices :',disabledTabIndices)
        setDisabledTabs(disabledTabIndices)
        if (disabledTabIndices.includes(selectedTab)) {
            const firstEnabledTab = tabPermissions.findIndex((_, index) => !disabledTabIndices.includes(index))
            setSelectedTab(firstEnabledTab !== -1 ? firstEnabledTab : 0)
        }

    },[selectedTab])

    const handleTabChange = (index) => {
        if (disabledTabs.includes(index)) return;
        setSelectedTab(index);
    };

    const handleSubTabChange = (index) => {
        setSelectedSubTab(index);

        switch (index) {
            case 0:
                toggleServiceEstimateSeries();
                break;
            case 1:
                toggleInvoiceSeries();
                break;
            case 2:
                toggleReceiptSeries();
                break;
            default:
                break;
        }
    };

    return (
        <div style={styles.mainContent}>
            <div className='title-container' style={{ paddingBottom: 10 }}>
                <h2 className='title'>Invoice Settings</h2>
            </div>

            <div >
                {/* <Tabs tabs={['Configuration','Receipt Narration & Notes','Organization','Receipt Books','Taxation','Auto Invoice']} */}
                <Tabs tabs={['Configuration', 'Receipt Narration & Notes', 'Manage Tax', 'Other Setting', 'Payment Gateway Settings']}
                    selectedIndex={selectedTab}
                    onTabChange={handleTabChange}
                    disabledTabs={disabledTabs}>
                    {selectedTab === 0 && !disabledTabs.includes(0) && <InvoiceSettingsConfigurationsScreen
                        showServiceEstimateSeries={showServiceEstimateSeries} editServiceEstimateSeries={editServiceEstimateSeries} selectedServiceEstimate={selectedServiceEstimate} toggleServiceEstimateSeries={toggleServiceEstimateSeries}
                        showInvoiceSeries={showInvoiceSeries} editInvoiceSeries={editInvoiceSeries} selectedInvoiceSeries={selectedInvoiceSeries} toggleInvoiceSeries={toggleInvoiceSeries}
                        showReceiptSeries={showReceiptSeries} editReceiptSeries={editReceiptSeries} selectedReceiptSeries={selectedReceiptSeries} toggleReceiptSeries={toggleReceiptSeries}
                        onRefresh={
                            showServiceEstimateSeries || editServiceEstimateSeries ? fetchEstimateSeriesHistory :
                                showInvoiceSeries || editInvoiceSeries ? fetchInvoiceSeriesHistory :
                                    showReceiptSeries || editReceiptSeries ? fetchReceiptSeriesHistory : null
                        } /> }
                    {selectedTab === 1 && !disabledTabs.includes(1) && <InvoiceReceiptNotesScreen narrationText={narration} notesText={notes} loadingSettings={loadingSettings} errorSettings={errorSettings} onRefresh={invoiceRefresh} /> }
                    {/* <InvoiceOrganizationScreen /> */}
                    {selectedTab === 2 && !disabledTabs.includes(2) && <InvoiceTaxationScreen taxSgst={taxSgst} taxCgst={taxCgst} taxIgst={taxIgst} taxConvFee={taxConvFee} loadingSettings={loadingSettings} errorSettings={errorSettings} onRefresh={invoiceRefresh} /> }
                    {/* {selectedTab === 3 && !disabledTabs.includes(3) && <InvoiceReceiptBooksScreen /> } */}
                    {selectedTab === 3 && !disabledTabs.includes(3) && <InvoiceOtherSettingsScreen bookOpenBalance={bookOpenBalance} overdueDays={overdueDays} loadingSettings={loadingSettings} errorSettings={errorSettings} onRefresh={invoiceRefresh} /> }
                    {selectedTab === 4 && !disabledTabs.includes(4) && <InvoicePaymentGatewayScreen paymentData={paymentData} paymentLoading={paymentLoading} paymentError={paymentError} onRefresh={fetchPaymentConfig} /> }
                </Tabs>
            </div>

            {selectedTab === 0 ? (
                <div >
                    <Tabs tabs={['Service Estimate Series', 'Invoice Series', 'Receipt Series']}
                        selectedIndex={selectedSubTab}
                        onTabChange={handleSubTabChange}>
                        <InvoiceServiceEstimateSeriesScreen seriesHistory={estimateSeries} loading={loadingEstimate} error={errorEstimate} toggleServiceEstimateSeries={toggleServiceEstimateSeries} toggleUpdateServiceEstimateSeries={toggleUpdateServiceEstimateSeries} onRefresh={fetchEstimateSeriesHistory} />
                        <InvoiceSeriesScreen seriesHistory={invoiceSeries} loading={loadingInvoice} error={errorInvoice} toggleInvoiceSeries={toggleInvoiceSeries} toggleUpdateInvoiceSeries={toggleUpdateInvoiceSeries} onRefresh={fetchInvoiceSeriesHistory} />
                        <InvoiceReceiptSeriesScreen seriesHistory={receiptSeries} loading={loadingReceipt} error={errorReceipt} toggleReceiptSeries={toggleReceiptSeries} toggleUpdateReceiptSeries={toggleUpdateReceiptSeries} onRefresh={fetchReceiptSeriesHistory} />
                    </Tabs>
                </div>
            ) : (
                null
            )
            }

        </div>


    )

};

const styles = {
    mainContent: {
        width: '95%',
        margin: 'auto'
    }

}

export default InvoiceSettingsScreen;